import { Injectable, Inject } from '@nestjs/common';
import { PostActivityEntity } from './post-activity.entity';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { PostActivityDTO} from './dto/post-activity.dto';
import { PostActivityResponseModel, PostActivitysharedResponseModel,   } from './dto/post-activity-response.model';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { PostPointsEntity } from '../post/post-points.entity';
import { PostEntity } from '../post/post.entity';
import { PostActivitySharedDTO } from './dto/Post-activity-shared.dto';
import { PostActivitySharedEntity } from './Post_activityshared.entity';
import { UserPointsEntity } from '../post/user-points.entity';
import { sendFCMNotifications } from '../shared/mobileOTP';
import { NotificationsEntity } from '../notifications/notifications.entity';
import { UserEntity } from '../user/user.entity';
import { HierarchyEntity } from '../hierarchy/hierarchy.entity';

@Injectable()
export class PostActivityService {
    constructor(
        @InjectRepository(PostActivityEntity)
        private postActivityRepository : Repository<PostActivityEntity>,
        @InjectRepository(PostPointsEntity)
        private postPointsRepo:Repository<PostPointsEntity>,
        @InjectRepository(PostEntity)
        private postRepo:Repository<PostEntity>,
        @InjectRepository(PostActivitySharedEntity)
        private postActivitysharedRepo:Repository<PostActivitySharedEntity>,
        @InjectRepository(UserPointsEntity)
        private userPointsRepo:Repository<UserPointsEntity>,
        @InjectRepository(NotificationsEntity)
        private notifyRepo:Repository<NotificationsEntity>,
        @InjectRepository(UserEntity)
        private useRepo:Repository<UserEntity>,
        @InjectRepository(HierarchyEntity)
        private hierarchyRepo: Repository<HierarchyEntity>,
    ) {}

    async sendNotify(text) {
        return await sendFCMNotifications(text)
        .then(() => {      
          console.log('notification sent successufully');
          return true;
        })
        .catch((err) => {
          console.log('error in sending notification ', err);
          return false;
        });
    }
    
    async createPostActivity(postActivityDto: PostActivityDTO, request: Request): Promise<PostActivityResponseModel>{
        const response = new PostActivityResponseModel();
        try {             
            const PostActivityEntityExists = await this.getPostActivitywithoutRealtions(postActivityDto.postId,postActivityDto.userId);
            const postData = await this.postRepo.findOne({
                relations:['user','user.profile'],
                where:{Id:postActivityDto.postId}
            }) 
            if(postData.text) {
                postData.text = postData.text.substring(0,10);
            }            
            if (PostActivityEntityExists) {
                postActivityDto.shared = PostActivityEntityExists.shared;
                if(postActivityDto.like!=null) {
                    postActivityDto.fev = PostActivityEntityExists.fev;
                    if(postActivityDto.like == true) {
                        postActivityDto.like = true;
                        postActivityDto.dislike = false;
                        const pointsData = {
                            postId:postActivityDto.postId,
                            userId:postData.userId,
                            actionBy:postActivityDto.userId,
                            points:1,
                            activity:'Like Post',
                            versionFlag: 1
                        }
                        const checkD = await this.postPointsRepo.findOne({
                            where:{postId:postActivityDto.postId,userId:postData.userId,points:1}
                        })
                        //if(!checkD) {
                            await this.postPointsRepo.save(pointsData)                        
                        //}
                        const checkData = await this.userPointsRepo.findOne({
                            where:{userId:pointsData.userId}
                        })
                        if(checkData) {
                            pointsData.points += checkData.points;
                            await this.userPointsRepo.update(checkData.Id, {points:pointsData.points})
                        } else {
                            await this.userPointsRepo.save({userId:pointsData.userId,points:pointsData.points})
                        }
                    } else {
                        postActivityDto.like = false;
                        postActivityDto.dislike = false;
                        await this.postPointsRepo.delete({postId:postActivityDto.postId,userId:postData.userId,points:1});
                        const checkData = await this.userPointsRepo.findOne({
                            where:{userId:postData.userId}
                        })
                        if(checkData) {
                            let pnt = checkData.points-1;
                            await this.userPointsRepo.update(checkData.Id, {points:pnt})
                        } 
                    }
                    const updateActivity = await this.postActivityRepository.update(PostActivityEntityExists.Id,postActivityDto);
                    if(updateActivity){
                        const updatedData = await this.postActivityRepository.findOne({
                            //relations:['post'],
                            where:{Id:PostActivityEntityExists.Id}
                        });
                        
                        if(postData.user.fcmToken) {
                            let msg = {
                                to : `${postData.user.fcmToken}`,
                                collapse_key : "type_a",
                                notification : {
                                    body : `${postData.user.profile.firstName} has Liked Your Post ${postData.text}`,
                                    title: "Post - Like"
                                },
                                data : {
                                    body : `${postData.user.profile.firstName} has Liked Your Post ${postData.text}`,
                                    title: "Post - Like",
                                    key_1 : "",
                                    key_2 : ""
                                }
                            }
                            
                            const nt = await this.sendNotify(msg);
                        }
                        await this.notifyRepo.save({
                            title:'Post - Like',
                            message:`${postData.user.profile.firstName} has Liked Your Post ${postData.text}`,
                            typeId:1,
                            userId:postData.userId,
                            targetId:postActivityDto.postId,
                            status:true
                        })
                        response.status = true;
                        response.data = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = postActivityDto.like == true? 'Post liked successfully':'Post like removed successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse (99998,'like not update')
                    }
                } else if(postActivityDto.dislike!=null){
                    postActivityDto.fev = PostActivityEntityExists.fev;
                    if(postActivityDto.dislike == true) {
                        postActivityDto.like = false;
                        postActivityDto.dislike = true;
                    } else {
                        postActivityDto.like = false;
                        postActivityDto.dislike = false;
                    }  
                    if(PostActivityEntityExists.like == true) {
                        await this.postPointsRepo.delete({postId:postActivityDto.postId,userId:postData.userId,points:1});
                        const checkData = await this.userPointsRepo.findOne({
                            where:{userId:postData.userId}
                        })
                        if(checkData) {
                            let pnt = checkData.points-1;
                            await this.userPointsRepo.update(checkData.Id, {points:pnt})
                        }
                    }                     
                    const updateActivity = await this.postActivityRepository.update(PostActivityEntityExists.Id,postActivityDto);
                    if(updateActivity){
                        const updatedData = await this.postActivityRepository.findOne({
                            //relations:['post'],
                            where:{Id:PostActivityEntityExists.Id}
                        });
                        response.status = true;
                        response.data = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = postActivityDto.dislike == true? 'Post disliked successfully':'Post dislike removed successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse (99998,'Dislike not updated')
                    }
                } else {                       
                    const updateActivity = await this.postActivityRepository.update(PostActivityEntityExists.Id,{fev:postActivityDto.fev});
                    if(updateActivity){
                        const updatedData = await this.postActivityRepository.findOne({
                            //relations:['post'],
                            where:{Id:PostActivityEntityExists.Id}
                        });
                        response.status = true;
                        response.data = updatedData;
                        response.statusCode = 50000;
                        response.internalMessage = postActivityDto.fev == true? 'Post favourite successfully':'Post favourite removed successfully';
                        response.intlCode = 11108;
                    } else {
                        throw new ErrorResponse (99998,'Favourite not updated')
                    }
                } 
            } else {
                const savedPostActivty = await this.postActivityRepository.save(postActivityDto);
                if(savedPostActivty){
                    if(postActivityDto.like == true) {
                        
                        if(postData.user.fcmToken) {
                            let msg = {
                                to : `${postData.user.fcmToken}`,
                                collapse_key : "type_a",
                                notification : {
                                    body : `${postData.user.profile.firstName} has Liked Your Post ${postData.text}`,
                                    title: "Post - Like"
                                },
                                data : {
                                    body : `${postData.user.profile.firstName} has Liked Your Post ${postData.text}`,
                                    title: "Post - Like",
                                    key_1 : "",
                                    key_2 : ""
                                }
                            }
                            
                            const nt = await this.sendNotify(msg);
                        }
                        await this.notifyRepo.save({
                            title:'Post - Like',
                            message:`${postData.user.profile.firstName} has Liked Your Post ${postData.text}`,
                            typeId:1,
                            userId:postData.userId,
                            targetId:postActivityDto.postId,
                            status:true
                        })
                        const pointsData = {
                            postId:postActivityDto.postId,
                            userId:postData.userId,
                            actionBy:postActivityDto.userId,
                            points:1,
                            activity:'Like Post',
                            versionFlag: 1
                        }
                        await this.postPointsRepo.save(pointsData)
                        const checkData = await this.userPointsRepo.findOne({
                            where:{userId:pointsData.userId}
                        })
                        if(checkData) {
                            pointsData.points += checkData.points;
                            await this.userPointsRepo.update(checkData.Id, {points:pointsData.points})
                        } else {
                            await this.userPointsRepo.save({userId:pointsData.userId,points:pointsData.points})
                        }
                    }
                    response.status = true;
                    response.data = savedPostActivty;
                    response.statusCode = 50000;
                    if(postActivityDto.like) response.internalMessage = 'Post liked successfully';
                    if(postActivityDto.dislike) response.internalMessage = 'Post disliked successfully';
                    if(postActivityDto.fev) response.internalMessage = 'Post favourite successfully';
                    response.intlCode = 11100;
                } else {
                    if(postActivityDto.like) {
                        throw new ErrorResponse (11106,'Post like failed ');
                    } else if(postActivityDto.dislike) {
                        throw new ErrorResponse (11106,'Post dislike failed ');
                    } else {
                        throw new ErrorResponse (11106,'Post favourite failed ');
                    }                            
                }
            }                                                           
            return response;
        } catch (error) { 
            throw error;
        } 
    }
    
    async getPostActivitywithoutRealtions(postId: number,userId: number) : Promise<PostActivityEntity>{
        const PostActivityResponse = await this.postActivityRepository.findOne({
            where: {postId:postId ,userId:  userId, status: true},
        });
        if (PostActivityResponse) {
            return PostActivityResponse;
        } else{
            return null;
        }
    }

     async getPostLikDisLikFavCount(postId) {
        try {
            const postActCount = await getConnection()
            .createQueryBuilder()
            .select("Sum(IF(like_status = true, 1, 0)) as likeCount,Sum(IF(dislike = true, 1, 0)) as dislikeCount,Sum(IF(fev = true, 1, 0)) as fevCount")
            .from(PostActivityEntity, "PostActivity")
            .where('post_id=:da', { da: postId })
            .orderBy('created_at','ASC')
            .getRawOne();
            if (postActCount) {
              return postActCount;
            } else {
              return null;
            }
        } catch (err) {
          throw err;
        }
     }

    async getPostLikDisLikFavStatus(postId,userId) {
        try {
            const postAct = await this.postActivityRepository.findOne({
                where:{postId:postId, userId:userId}
            })
            if(postAct) {
                return postAct;
            } else {
                return null;
            }
        } catch (error) {
            throw error;
        }
    }

    async createPostActivityshared( PostActivitySharedDTO: PostActivitySharedDTO,queryParams, request: Request): Promise<PostActivitysharedResponseModel> {
        const response = new PostActivitysharedResponseModel();
        try {
            let userAry: any[] = [];
            const PostActivityEntityExists = await this.getPostActivitywithoutRealtions(PostActivitySharedDTO.postId,PostActivitySharedDTO.sharedBy);
            const postData = await this.postRepo.findOne({
                where:{Id:PostActivitySharedDTO.postId}
            })
            var users = await this.hierarchyRepo.find({
                where:{nextLevelLoginId:PostActivitySharedDTO.sharedBy,status:true}
            })
            users.map((u) => {
                userAry.push(u.masterLoginId)
            })
            if(queryParams.apiVersion == 1) {
                for(let i=0; i < userAry.length;i++) {
                    PostActivitySharedDTO.sharedWith = userAry[i];
                    await this.postActivitysharedRepo.save(PostActivitySharedDTO)
                }

                if(userAry.length > 0) {
                    const pointsData = {
                        postId:PostActivitySharedDTO.postId,
                        userId:postData.userId,
                        actionBy:PostActivitySharedDTO.sharedBy,
                        points:3,
                        activity:'Share Post',
                        versionFlag: 1
                    }
                    await this.postPointsRepo.save(pointsData)
                    const checkData = await this.userPointsRepo.findOne({
                        where:{userId:pointsData.userId}
                    })
                    if(checkData) {
                        pointsData.points += checkData.points;
                        await this.userPointsRepo.update(checkData.Id, {points:pointsData.points})
                    } else {
                        await this.userPointsRepo.save({userId:pointsData.userId,points:pointsData.points})
                    }
                    if(PostActivityEntityExists) {
                        if(PostActivityEntityExists.shared == null || PostActivityEntityExists.shared < 1){
                            await this.postActivityRepository.update(PostActivityEntityExists.Id,{shared:1});
                        } else {
                            PostActivityEntityExists.shared+=1;
                            await this.postActivityRepository.update(PostActivityEntityExists.Id,{shared:PostActivityEntityExists.shared});
                        }
                    } else {
                        await this.postActivityRepository.save({postId:PostActivitySharedDTO.postId,userId:PostActivitySharedDTO.sharedBy,shared:1,createdUser:PostActivitySharedDTO.sharedBy});
                    }       
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Activity shared Created Successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Post Activity shared Not Created')
                }
            } else {
                for(let i=0; i < userAry.length;i++) {
                    PostActivitySharedDTO.sharedWith = userAry[i];
                    await this.postActivitysharedRepo.save(PostActivitySharedDTO)
                }

                if(userAry.length > 0) {
                    const pointsData = {
                        postId:PostActivitySharedDTO.postId,
                        userId:postData.userId,
                        actionBy:PostActivitySharedDTO.sharedBy,
                        points:3,
                        activity:'Share Post',
                        versionFlag: 1
                    }
                    await this.postPointsRepo.save(pointsData)
                    const checkData = await this.userPointsRepo.findOne({
                        where:{userId:pointsData.userId}
                    })
                    if(checkData) {
                        pointsData.points += checkData.points;
                        await this.userPointsRepo.update(checkData.Id, {points:pointsData.points})
                    } else {
                        await this.userPointsRepo.save({userId:pointsData.userId,points:pointsData.points})
                    }
                    if(PostActivityEntityExists) {
                        if(PostActivityEntityExists.shared == null || PostActivityEntityExists.shared < 1){
                            await this.postActivityRepository.update(PostActivityEntityExists.Id,{shared:1});
                        } else {
                            PostActivityEntityExists.shared+=1;
                            await this.postActivityRepository.update(PostActivityEntityExists.Id,{shared:PostActivityEntityExists.shared});
                        }
                    } else {
                        await this.postActivityRepository.save({postId:PostActivitySharedDTO.postId,userId:PostActivitySharedDTO.sharedBy,shared:1,createdUser:PostActivitySharedDTO.sharedBy});
                    }       
                    response.status = true;
                    response.statusCode = 50000;
                    response.internalMessage = 'Post Activity shared Created Successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Post Activity shared Not Created')
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }


    
  
}




























































